"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveReferralCodesOptions = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
let RetrieveReferralCodesOptions = class RetrieveReferralCodesOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
};
exports.RetrieveReferralCodesOptions = RetrieveReferralCodesOptions;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], RetrieveReferralCodesOptions.prototype, "referrerIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], RetrieveReferralCodesOptions.prototype, "onlyUsed", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RetrieveReferralCodesOptions.prototype, "code", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RetrieveReferralCodesOptions.prototype, "orderId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], RetrieveReferralCodesOptions.prototype, "customerIds", void 0);
exports.RetrieveReferralCodesOptions = RetrieveReferralCodesOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveReferralCodesOptions);
//# sourceMappingURL=RetrieveReferralCodesOptions.js.map